import styled from '@emotion/styled';
import { ResponsiveDiv } from './Responsive';

export const MobileContainer = styled(ResponsiveDiv)`
  position: relative;
  margin-top: -1px;
`;
